import {
  Box,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Typography,
} from '@mui/material';
import axios from 'axios';
import { DispalyFileFormLink, OrderDetail } from 'Components/Orders/SageOrders/SageOrders';
import { mapStatusRegelement } from 'Components/Payment/AttachInvoicesPayment/constants';
import { format } from 'date-fns';
import React, {
  useCallback, useContext, useMemo, useState,
} from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import EnhancedTable from 'Shared/EnhancedTable';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import UserContext from 'Shared/UserContext';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DialogCmp from 'Shared/Dialog';
import useOnClickOutside from 'Shared/Hooks/useClickOutSide';
import { DEPOSITS_O } from 'Shared/constants/order';
import { useSelector } from 'react-redux';
import { makeSelectSalers } from 'selectors';
import ReferencialContext from 'Shared/ReferencialContext';
import Filters from '../Filters';
import {
  defaultMessage, downloadBL, getOrders, deleteOrder,
} from '../RecoveryServices';
import {
  columns, columnsSAV, DOCUMENTS, downloadFromLink, mapOrderStatus,
} from './constants';
import useStyles from './style';
import useAppliedFilter from '../useAppliedFilter';
import { SOUCHES } from '../constants';

let cancelToken;
const Orders = () => {
  const {
    state: { user },
  } = useContext(UserContext);
  const {
    state: {
      referencial: {
        clients = [],
      },
    },
  } = useContext(ReferencialContext);
  const history = useHistory();
  const salers = useSelector(makeSelectSalers());
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState({ content: [] });
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);
  const [order, setOrder] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const [openDisplayFile, setOpenDisplayFile] = useState(false);
  const [fileLink, setFileLink] = useState(null);
  const classes = useStyles();
  const isSAV = user.role === 'SAV';
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {
    setValues, handleRefresh, values, appliedFilter, onHandleSubmitFilters,
  } = useAppliedFilter();
  const open = Boolean(anchorEl);
  const id = open ? 'transitions-popper' : undefined;
  const arrowRef = React.useRef();
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  useOnClickOutside(arrowRef, () => setAnchorEl(false));

  const handleStateNewOrderPopup = () => {
    history.push('/o-add');
  };
  const handleInputChange = (prop) => (event, value) => {
    if (event?.toString() !== 'Invalid Date') {
      setValues((prev) => ({
        ...prev,
        [prop]: event instanceof Date ? event : value || event?.target.value,
      }));
    }
  };
  const getOrderList = useCallback(
    async (sort) => {
      try {
        setLoading(true);
        if (typeof cancelToken !== typeof undefined) {
          cancelToken.cancel('Cancel');
        }
        cancelToken = axios.CancelToken.source();
        let controlled;
        if (appliedFilter.controlled) {
          controlled = appliedFilter.controlled.value === 'CONTROLED';
        }
        const data = await getOrders(
          sort,
          {
            city: appliedFilter.city,
            controlled,
            zone: appliedFilter.zone,
            client: appliedFilter?.client?.map((c) => c.code),
            expedition: appliedFilter?.expedition?.map((c) => c.code),
            paymentMode: appliedFilter?.paymentMode?.map((c) => c.code),
            statusP: appliedFilter?.statusP?.value,
            commercial: appliedFilter.commercial?.map((c) => c.id),
            startDate: appliedFilter.startDate
              ? format(
                appliedFilter.startDate instanceof Date
                  ? appliedFilter.startDate : new Date(appliedFilter.startDate),
                'yyyy-MM-dd',
              )
              : undefined,
            endDate: appliedFilter.endDate
              ? format(
                appliedFilter.endDate instanceof Date
                  ? appliedFilter.endDate : new Date(appliedFilter.endDate),
                'yyyy-MM-dd',
              )
              : undefined,
            numCommande: appliedFilter.numCommande,
            numExpedition: appliedFilter.numExpedition,
            type: appliedFilter.type?.id,
            deposit: appliedFilter.deposit,
          },
          { cancelToken: cancelToken.token },
        );
        setOrders(data);
      } catch (e) {
        if (e.message !== 'Cancel') {
          const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
          toast.error(statusLabel);
        }
      } finally {
        setLoading(false);
      }
    },
    [setOrders, setLoading, appliedFilter],
  );

  const handleSelectOrder = (o) => {
    setOrder(o);
    setOrderNumber(o.reference);

    setOpenDetail(true);
  };
  const getBL = useCallback(
    async (idf, bl) => {
      try {
        setLoading(true);
        await downloadBL(idf, bl);
      } catch (e) {
        const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
        toast.error(statusLabel);
      } finally {
        setLoading(false);
      }
    },
    [setLoading],
  );

  const handleDisplayExpedition = (link) => {
    setFileLink(link);
    setOpenDisplayFile(true);
  };

  const salesOrders = useMemo(
    () => orders.content.map((o, index) => ({
      ...o,
      id: index,
      realId: o.id,
      amountTTC: o.details
        .reduce((prev, curr) => prev + curr.montantTtc, 0)
        ?.toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$& '),
      amountHT: o.details
        .reduce(
          (prev, curr) => prev + (curr.prixUnitaire * curr.quantity * (100 - curr.remise)) / 100,
          0,
        )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$& '),
      restAmount: (o.amount - o.paidAmount).toFixed(2),
      client: `${o.client?.code}: ${o.client?.name}`,
      oc: o.client,
      paymentMode: o.paymentMode?.name,
      opMode: o.paymentMode,
      expedition: o.expedition?.name,
      oexpedition: o.expedition,
      expeditionNum: o.numExpedition,
      commercial: `${o.details[0]?.commercial?.firstName} ${o.details[0]?.commercial?.lastName}`,
      city: o.client?.city,
      click: () => handleSelectOrder(o),
      noColor: o.noAnomaly,
      orange: o.quantityDifference || o.priceAndDiscountDifference,
      red: o.falseReference,
      greeen: o.paymentModeChange || o.expeditionModeChange || o.expeditionmodeChange,
      statusP: o.reglementStatus && mapStatusRegelement[o.reglementStatus]?.label,
      statusO:
        mapOrderStatus[o.status && o.status.status ? o.status.status : 'NON_ASSIGNEE']?.label,
      statusClass:
        classes[
          mapOrderStatus[o.status && o.status.status ? o.status.status : 'NON_ASSIGNEE'].class
        ],
      handleDownloadBl: (bl) => (event) => {
        event.stopPropagation();
        getBL(o.reference, bl);
        setAnchorEl(null);
      },
      handleDisplayCoord1: (link) => (event) => {
        event.stopPropagation();
        handleDisplayExpedition(link);
        setAnchorEl(null);
      },
      handleEdit: (order_) => (event) => {
        event?.stopPropagation();
        const orderEdit = {
          sageId: order_.id,
          reference: order_.currentReference,
          saler: salers.find((s) => s.id === order_.commercialId),
          colisage: order_.colisage,
          date: order_.date,
          totalWeight: order_.totalWeight, // totalWeight ok
          type: order_.type,
          numExpedition: order_.expeditionNum,
          biller: { userName: order_.biller },
          client: clients?.find((c) => c.code === order_.oc?.code),
          expedition: order_.oexpedition
            ? { ...order_.oexpedition, code: order_.oexpedition?.id } : null,
          packedBy: { userName: order_.picker },
          paymentMode: order_.opMode
            ? { ...order_.opMode, code: order_.opMode?.id } : null,
          picker: { userName: order_.picker },
          repo: DEPOSITS_O.find((d) => d.id === order_.repoId),
          souche: SOUCHES.find((s) => s.id === order_.souche),
          products: order_.details.map((p) => ({
            product: p.product,
            productName: p.designation,
            amountTtc: p.montantTtc,
            quantity: p.quantity,
            remise: p.remise,
            price: p.prixUnitaire,
          })),
        };
        history.push('/payment/orders/add', { docType: orderEdit.type, doc: orderEdit });
        setAnchorEl(null);
      },
      openPopOver: (row) => (event) => {
        event?.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setSelectedRow(row);
      },
    })),
    [orders, handleDisplayExpedition, getBL, handleSelectOrder, handleSelectOrder],
  );

  const handleDeleteOrder = useCallback(async () => {
    try {
      setLoading(true);
      const response = await deleteOrder(selectedRow.realId);

      if (response && response.statusCode === '400') {
        toast.error(response.statusLabel || 'Order not found');
        setOpenConfirmDelete(false);
        setAnchorEl(null);
        return;
      }

      const updatedOrders = orders.content.filter((o) => o.reference !== selectedRow.reference);
      setOrders({ ...orders, content: updatedOrders });

      toast.success('Document supprimé avec succès');
      setOpenConfirmDelete(false);
      setAnchorEl(null);
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    } finally {
      setLoading(false);
    }
  }, [selectedRow, orders, setOrders]);

  const handleOpenConfirmDelete = () => {
    setOpenConfirmDelete(true);
    setAnchorEl(null);
  };

  return (
    <>
      {loading && <GlobalLoader size="100vh" />}
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        ref={arrowRef}
        className={classes.popper}
        disablePortal
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'scrollParent',
          },
          arrow: {
            enabled: true,
            element: arrowRef,
          },
        }}
      >
        <Paper
          className={{
            maxWidth: 400,
            overflow: 'auto',
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            boxShadow: '0px 12px 26px #0000001C',
            border: '1px solid #F7F7F7',
          }}
        >
          <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
            <ListItem button onClick={selectedRow?.handleEdit(selectedRow)}>
              <ListItemIcon>
                <EditIcon style={{ color: '#38485C' }} />
              </ListItemIcon>
              <ListItemText
                primary={(
                  <Typography
                    style={{ color: '#38485C', font: 'normal normal 600 16px/19px Montserrat' }}
                  >
                    Modifier Le Document
                  </Typography>
                )}
              />
            </ListItem>
            {DOCUMENTS[selectedRow?.type] && (
              <ListItem
                button
                onClick={selectedRow?.handleDownloadBl([3, 4].includes(selectedRow?.type))}
              >
                <ListItemIcon>
                  <GetAppIcon style={{ color: '#38485C' }} />
                </ListItemIcon>
                <ListItemText
                  primary={(
                    <Typography
                      style={{ color: '#38485C', font: 'normal normal 600 16px/19px Montserrat' }}
                    >
                      Télecharger le document
                    </Typography>
                  )}
                />
              </ListItem>
            )}
            {selectedRow?.coord1 && (
              <ListItem
                button
                onClick={downloadFromLink(selectedRow?.coord1,
                  selectedRow?.currentReference, () => setAnchorEl(null))}
              >
                <ListItemIcon>
                  <GetAppIcon style={{ color: '#38485C' }} />
                </ListItemIcon>
                <ListItemText
                  primary={(
                    <Typography
                      style={{ color: '#38485C', font: 'normal normal 600 16px/19px Montserrat' }}
                    >
                      Télécharger la déclaration d&apos;expédition
                    </Typography>
                  )}
                />
              </ListItem>
            )}
            {selectedRow?.coord1 && (
              <ListItem button onClick={selectedRow?.handleDisplayCoord1(selectedRow?.coord1)}>
                <ListItemIcon>
                  <VisibilityIcon style={{ color: '#38485C' }} />
                </ListItemIcon>
                <ListItemText
                  primary={(
                    <Typography
                      style={{ color: '#38485C', font: 'normal normal 600 16px/19px Montserrat' }}
                    >
                      Aperçu la déclaration d&apos;expédition
                    </Typography>
                  )}
                />
              </ListItem>
            )}
            <ListItem button onClick={handleOpenConfirmDelete}>
              <ListItemIcon>
                <DeleteIcon style={{ color: '#F86060' }} />
              </ListItemIcon>
              <ListItemText
                primary={(
                  <Typography
                    style={{ color: '#F86060', font: 'normal normal 600 16px/19px Montserrat' }}
                  >
                    Supprimer
                  </Typography>
                )}
              />
            </ListItem>
          </List>
        </Paper>
      </Popper>
      <Box
        style={{
          display: 'flex',
          padding: 10,
          alignItems: 'center',
          background: '#E9EBED 0% 0% no-repeat padding-box',
          bordeRradius: '0px 0px 12px 12px',
          opacity: 1,
          marginBottom: 16,
        }}
      >
        <Filters
          values={values}
          handleInputChange={handleInputChange}
          product
          handleRefresh={handleRefresh}
          onSubmitSearch={onHandleSubmitFilters}
        />
        {!isSAV && (
          <Button
            variant="contained"
            style={{ minWidth: '230px' }}
            color="primary"
            onClick={handleStateNewOrderPopup}
          >
            Ajouter une commande
          </Button>
        )}
      </Box>
      <OrderDetail
        orderNumber={orderNumber}
        open={openDetail}
        setOpen={setOpenDetail}
        order={order}
      />
      <DispalyFileFormLink link={fileLink} open={openDisplayFile} setOpen={setOpenDisplayFile} />
      <DialogCmp
        title=""
        endIcon={false}
        fullWidth={false}
        open={openConfirmDelete}
        handleClose={() => setOpenConfirmDelete(false)}
        onHandleSubmit={handleDeleteOrder}
        labelKo="Non"
        labelOk="Oui"
        styleOk={{
          boxShadow: '0px 4px 10px #BEBEBE50',
          height: '48px',
          width: '161px',
          background: '#F86060',
          border: '1px solid #EBEDED',
          borderRadius: '12px',
          padding: '0 24px',
          font: 'normal normal 600 16px Montserrat',
          color: '#FFFFFF',
        }}
        styleKo={{
          height: '48px',
          width: '161px',
          background: '#FFFFFF',
          boxShadow: '0px 4px 10px #BEBEBE50',
          border: '1px solid #EBEDED',
          borderRadius: '12px',
          padding: '0 24px',
          font: 'normal normal 600 16px Montserrat',
          color: '#000000',
        }}
        actionStyle={{ display: 'flex', justifyContent: 'center' }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            width: '80%',
            margin: 'auto',
            gap: '26px',
          }}
        >
          <Box sx={{
            width: '114px',
            height: '114px',
            background: '#F86060',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >
            <DeleteIcon fontSize="large" sx={{ color: '#FFF' }} />
          </Box>
          <Typography sx={{
            textAlign: 'center',
            font: 'normal normal 500 28px Montserrat',
            color: '#000000',
          }}
          >
            Voulez-vous vraiment supprimer ce document?
          </Typography>
        </Box>
      </DialogCmp>
      <EnhancedTable
        getData={getOrderList}
        rows={salesOrders}
        headCells={isSAV ? columnsSAV : columns}
        count={orders.totalElements}
        rowsPerPageOptions={[10, 15, 20]}
      />
    </>
  );
};

export default Orders;
